import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: {
        position: 'relative', display: 'flex', flexDirection: 'column', color: '#fff', fontFamily: 'Montserrat, sans-serif', fontSize: 18, borderBottom: '1px solid rgba(0,0,0,.3)', width: '100%', textAlign: 'center', paddingTop: 20, paddingBottom: 20
    },
    provider: {
        position: 'absolute', 
        top: 10, 
        right: 10, 
        fontSize: 14, 
        color: '#3cde0b',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'rgb(255, 255, 255,.3)',
        borderRadius: '4px',
        padding: '5px 10px',
        fontWeight: 700
    },
    percent: {
        color: '#fff',
        fontSize: 16,
        fontFamily: 'PT-sans, sans-serif',
    },
    wrapBlock: {
        display: 'flex', 
        alignItems: 'center', 
        flexDirection: 'column'
    },
    mb: {
        marginBottom: 8
    },
    helper: {
        color: 'hsla(0,0%,100%,.5)',                   
        fontSize: '14px',  
        fontFamily: 'PT-sans, sans-serif',
        paddingBottom: 4
    },
    description: {
        color: '#fff',
        fontSize: 14,
        fontFamily: 'PT-sans, sans-serif',
    },
    wrap: {
        padding: '0 20px', 
        display: 'flex', 
        justifyContent: 'space-between', 
        columnGap: 5
    },
    w50: {
        width: '50%'
    }
}))

export {
    useStyles
}